module.exports = __webpack_public_path__ + "img/chongqing.c9da4759.jpg";